const domainDeviceEn = {
  components: {
    deviceFilters: {
      search: {
        placeholder: "Filter devices ...",
        clear: "Clear Search",
      },
      deviceGenre: {
        label: "Device Type",
        placeholder: "Select type",
        all: "Genre",
      },
      assigned: {
        label: "Unassigned Devices",
      },
      reportStatus: {
        label: "Self Report",
        placeholder: "Self Report",
        all: "Report Review Status",
        completed: "Completed",
        notCompleted: "Not Completed",
      },
      error: {
        label: "Error",
      },
    },
    deviceToolbar: {
      showSummary: "Show Summary",
    },
    statCard: {
      totalDevices: "Devices",
      assignedDevices: "Assigned Devices",
      installedDevices: "Installed Devices",
      responsiblePersons: "Responsible & Owners",
    },
  },
  activityType: {
    PROCURED: "procured",
    ORDERED: "ordered",
    DECOMMISSIONED: "decommissioned",
    TROUBLED: "troubled",
    RECOVERED: "recovered",
  },
  genre: {
    WORKSTATION: "Workstation",
    LAPTOP: "Laptop",
    MOBILE: "Mobile",
    TABLET: "Tablet",
    MONITOR: "Monitor",
    SERVER: "Server",
    OTHER: "Other",
  },
  type: {
    computer: "Desktop, Laptop",
    mobile: "Mobile, Tablet",
    monitor: "Monitor",
    server: "Server",
    other: "Others",
    short: {
      computer: "Desktop, Laptop",
      mobile: "Mobile, Tablet",
      monitor: "Monitor",
      server: "Server",
      other: "Others",
    },
  },
  osPlatformType: {
    WINDOWS: "Windows",
    LINUX: "Linux",
    ANDROID: "Android",
    MACOS: "macOS",
    IOS: "iOS",
    TVOS: "tvOS",
    WATCHOS: "watchOS",
    VISIONOS: "visionOS",
    OTHER: "Other",
  },
  storageType: {
    SSD: "SSD",
    HDD: "HDD",
    UNKNOWN: "Unknown",
  },
  networkInterfaceType: {
    UNKNOWN: "Unknown",
    ETHERNET: "Ethernet",
    IEEE_802_11: "WiFi",
    IEEE_802_15_1: "Bluetooth",
  },
  purchaseCondition: {
    NEW: "New",
    USED: "Used",
  },
  procurementType: {
    PURCHASE: "Purchase",
    LEASE: "Lease",
    RENTAL: "Rental",
    OTHER: "Other",
  },
  inventoryLabel: {
    labelPreviewDialog: {
      title: "Asset management label",
    },
    printLabel: {
      generatePdf: "Generate PDF",
      printOptions: {
        assetTag: "Asset tag",
        qrCode: "QR code",
        deviceName: "Device name",
        none: "None",
        labelSize: "Label size",
        paperSize: "Paper size",
        margin: "Margin",
        labelType: "Label type",
        labelColor: "Label color",
        labelFont: "Label font",
        labelFontSize: "Label font size",
        additionalContent: "Additional content",
        layout: "Layout",
        vertical: "Vertical",
        horizontal: "Horizontal",
      },
      labelSpecs: {
        "65_labels_A4": "65 labels size (A4)",
        "21_labels_A4": "21 labels size (A4)",
        "12_labels_A4": "12 labels size (A4)",
        "10_labels_A4": "10 labels size (A4)",
      },
    },
  },
};

export default domainDeviceEn;
